/**
 * @file 首頁類型常數
 * @description 定義首頁相關的路由類型常數
 */
const homePageType = {
  home: '/', //首頁
  member: '/member' //會員管理
} as const;

export type HomePageTypeKey = keyof typeof homePageType;
export type HomePageTypeValue = (typeof homePageType)[HomePageTypeKey];

export default homePageType;
